import { Component, OnDestroy, OnInit } from '@angular/core';
import { LaunchpadEvents } from 'app/models/LaunchpadEvents';

@Component({
  selector: 'app-components-navigation-admin',
  templateUrl: './Admin.component.html'
})
export class AdminComponent implements OnInit, OnDestroy {
  showDevToolsSubMenu = false;
  showProductToolsSubMenu = false;

  private urlChangedHandler: (newHash: string) => void = (newHash: string) => {
    this.urlUpdated(newHash);
  };

  private devToolsPages: string[] = [
    'admin/workflows',
    'admin/internaltaskhistory',
    'admin/applicationmanagement',
    'admin/translations',
    'admin/partnerusers',
    'admin/viewtaskworkspace'
  ];

  private productToolsPages: string[] = [
    'admin/verticalmanagement',
    'admin/helptexteditor',
    'admin/countryandlanguagemanagement'
  ];

  ngOnInit(): void {
    amplify.subscribe(LaunchpadEvents.urlChanged, this.urlChangedHandler);
  }

  ngOnDestroy(): void {
    amplify.unsubscribe(LaunchpadEvents.urlChanged, this.urlChangedHandler);
  }

  private urlUpdated(newHash: string): void {
    if (this.devToolsPages.indexOf(newHash) > -1) {
      this.showDevToolsSubMenu = true;
      this.showProductToolsSubMenu = false;
    } else if (this.productToolsPages.indexOf(newHash) > -1) {
      this.showDevToolsSubMenu = false;
      this.showProductToolsSubMenu = true;
    } else {
      this.showDevToolsSubMenu = false;
      this.showProductToolsSubMenu = false;
    }
  }
}
